import { Skeleton } from 'antd';
import styled from 'styled-components';

// Same outer size as the loaded box: 22px line + 2 x 12px padding + 2 x 1px border = 48px.
export const StyledProductsTotalSkeleton = styled(Skeleton.Input)`
    && {
        width: 240px;
        min-width: 240px;
        height: 48px;
        border-radius: 6px;
    }

    .ant-skeleton-input {
        width: 240px;
        min-width: 240px;
        height: 48px;
        border-radius: 6px;
    }
`;

export const StyledProductsTotal = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 12px 16px;
    border: 1px solid var(--brand-3);
    border-radius: 6px;
    background: rgba(233, 230, 245, 0.5);
    font-size: 14px;
    line-height: 22px;
    color: var(--gray-10);
`;

export const StyledProductsTotalIcon = styled.span`
    display: flex;
    font-size: 16px;
    color: var(--brand-6);
`;

export const StyledProductsTotalLabel = styled.span`
    display: flex;
    align-items: center;
    gap: 4px;

    strong {
        font-weight: 600;
        color: #000;
    }
`;
